import { useEffect } from 'react';
import { isDesktop } from 'shared/lib';

const TOAST_HEIGHT = 60;
const TOAST_HEIGHT_ASPECT = TOAST_HEIGHT / 1024;

const TOAST_WIDTH = 312;
const TOAST_WIDTH_ASPECT = TOAST_WIDTH / 1920;

export const useScaleNotifications = () => {
	useEffect(() => {
		const handleResize = () => {
			const toast = document.getElementsByClassName('Toastify')[0] as HTMLDivElement;

			if (!toast) return;
			const width = document.documentElement.clientWidth;
			const height = document.documentElement.clientHeight;

			if (isDesktop(width, height)) {
				const scaleX = (TOAST_WIDTH_ASPECT * width) / TOAST_WIDTH;
				const scaleY = (TOAST_HEIGHT_ASPECT * height) / TOAST_HEIGHT;

				toast.style.setProperty('--scale', `${Math.max(scaleX, scaleY)}`);

				return;
			}

			toast.style.setProperty('--scale', '1');
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
};
